import React from 'react';

const Wishlists = () => {
    return (
        <div>
            <h2>This is wishlists</h2>
        </div>
    );
};

export default Wishlists;